<template>
  <section
    v-if="showBox"
    class="box">
    <div class="top-container">
      <span
        class="icon-box"
        :class="{'icon-box__white':iconStatus}"
        @click="handleStatus">
        <font-awesome-icon
          v-if="!iconStatus"
          class="fs-16"
          icon="bookmark"></font-awesome-icon>
        <font-awesome-icon
          v-else
          class="fs-16"
          icon="xmark"></font-awesome-icon>
      </span>
      <!--      <font-awesome-icon class="fs-16" icon="xmark"></font-awesome-icon>-->
    </div>
    <template v-if="iconStatus">
      <section
        class="reminder-box"
        :class="{'auto-height':isOpen}">
        <span class="header flex-align-center">
          <span class="title color-dark fw-600 mg-b-0">Reminder</span>
          <span
            class="flex mg-l-15 pointer"
          >
            <font-awesome-icon
              class="color-gray60"
              icon="file"
            ></font-awesome-icon>
            <span class="fs-14 fw-400 color-dark mg-l-4">{{file.length}}</span>
          </span>
          <span
            class="flex mg-l-15 pointer"
          >
            <font-awesome-icon
              class="color-gray60"
              icon="comment"
            ></font-awesome-icon>
            <span class="fs-14 fw-400 color-dark mg-l-4">{{reminder_remark.length}}</span>
          </span>
          <span
            class="flex mg-l-15 pointer"
          >
            <font-awesome-icon
              class="color-gray60"
              icon="ticket-alt"
            ></font-awesome-icon>
            <span class="fs-14 fw-400 color-dark mg-l-4">{{pre_order_claim.length}}</span>
          </span>
        </span>
        <section class="box-container">
          <div
            v-if="file.length>0"
            class="doc-container">
            <span class="doc-title block fs-14 fw-600 color-dark">Documents</span>
            <div
              v-for="(item,index) in file"
              :key="'file_'+index"
              :class="{'last-border':reminder_remark.length<=0&&pre_order_claim.length<=0}"
              class="doc-item">
              <span><font-awesome-icon
                class="fs-16 blue"
                icon="file"></font-awesome-icon></span>
              <span
                class="blue mg-l-4 fs-14 fw-400 pointer"
                @click="openUrl(item.url)">{{renewFileTypeName[item.type]}}</span>
              <span
                class="doc-tips"
                v-html="changeLineText(item.remark)">
              </span>
              <span class="flex-sb-center">
                <span class="fs-12 fw-400 color-dark">{{item.created_date}}</span>
                <span class="fs-12 name-content">{{item.cs_nm}}</span>
              </span>
            </div>
          </div>
          <div
            v-if="reminder_remark.length>0"
            class="doc-container "
            :class="{'doc-bottom-border':pre_order_claim.length>0}">
            <span class="doc-title block fs-14 fw-600 color-dark mg-b-20">Reminder Remarks</span>
            <div
              v-for="(item, index) in reminder_remark"
              :key="index"
              class="doc-item_remark">
              <span class="flex-sb-center mg-b-5">
                <span class="fs-12 fw-600 color-gray60">{{ item.cs_nm }}</span>
                <span class="fs-12 fw-400 color-gray60">{{ item.created_at }}</span>
              </span>
              <span
                class="doc-tips"
                v-html="changeLineData(item.remark)">
              </span>
            </div>
          </div>
          <div
            v-if="pre_order_claim.length>0"
            class="doc-container">
            <span class="doc-title block fs-14 fw-600 color-dark mg-b-20">Claims Tickets</span>
            <span  class="doc-item ">
              <span
                v-for="(item,index) in pre_order_claim"
                :key="'pre_order_claim-'+index"
                class="flex mg-b-10">
                <font-awesome-icon
                  class="fs-16 blue"
                  icon="file"></font-awesome-icon>
                <span class="blue mg-l-4 fs-14 fw-400">{{item}}</span>
              </span>
            </span>
          </div>
        </section>
      </section>
    </template>
  </section>
</template>

<script>
import {renewFileTypeName} from '@/utils/renew_type'
import MixinOptions from '@/mixins/options'

export default {
  name: 'reminder-detail',
  mixins: [MixinOptions],
  props:{
    form:{
      type:Object,
      default:()=>({})
    }
  },
  data(){
    return{
      iconStatus:true,
      isOpen:false
    }
  },
  computed:{
    relation(){
      return this.form
    },
    reminder_remark(){
      let {reminder_remark} = this.relation||{}
      return reminder_remark||[]
    },
    file(){
      let {file} = this.relation||{}
      return file||[]
    },
    isCompany(){
      let {customer} = this.form||{}
      let {identity} = customer||{}
      return identity==2
    },
    pre_order_claim(){
      let {pre_order_claim} = this.relation||{}
      return pre_order_claim||[]
    },
    renewFileTypeName(){
      let type_name = renewFileTypeName
      if(this.isCompany)
        type_name.id_type_pic_path = 'Certificate of Incorporation/Business Registration Certificate'
      return type_name
    },
    showBox(){
      return this.file.length>0||this.reminder_remark.length>0||this.pre_order_claim>0
    }
  },
  methods:{
    handleStatus(){
      this.iconStatus = !this.iconStatus
      if(this.isOpen) this.isOpen = false
    },
    handleOverflow(){
      this.isOpen = true
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  height: calc(100vh - 40px);

  .top-container {
    height: 42px;
    width: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    position: fixed;
    right: 0px;
    top: 250px;
    z-index: 100;
    border-radius: 12px 0 0 12px;
    background: #fff;
    cursor: pointer;
    .icon-box {
      height: 42px;
      width: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: $skyBlue;
      color: #fff;
      border-radius: 12px 0 0 12px;
      padding: 4px 0 4px 4px;
      border: 4px solid #fff;
      border-right: 0;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      &__white{
        background: #fff;
        color: $skyBlue;
      }
      &:hover {
        opacity: 0.5;
      }
    }
  }

  .blur-out {
    animation: fade-out 2s forwards;
    filter: blur(0);
  }

  .reminder-box {
    width: 320px;
    height: 420px;
    border-radius: 6px;
    border: 1px solid #D1D5DA;
    background: rgba(250, 251, 252, 1);
    margin-top: 25px;
    overflow: hidden;
    overflow-y: auto;
    position: fixed;
    right: 25px;
    z-index: 99;
    &.auto-height{
      height: auto;
      background: #fff;
      overflow: auto;
    }
    .box-container{
      height: 356px;
      overflow-y: auto;
    }
    .top-container {
      height: 42px;
      width: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 2px 5px 0px #0000000D;

      .icon-box {
        height: 32px;
        width: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: $skyBlue;
      }
    }

    .mg-l-4 {
      margin-left: 4px;
    }

    .header {
      display: flex;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #D1D5DA;

      .title {
        font-size: 16px;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }

    .doc-container {
      padding: 20px;
      &.doc-bottom-border{
        border-bottom: 1px solid #D1D5DA;
        margin: 0 20px;
        padding: 0;
        padding-bottom: 20px;
      }
      .doc-item_remark{
        .doc-tips {
          display: block;
          margin: 5px 0;
          font-size: 14px;
          font-weight: 400;
          color: $dark;
        }
      }
      .doc-item {
        padding-bottom: 20px;
        padding-top: 20px;
        border-bottom: 1px solid #D1D5DA;
        &:last-child{
          &.last-border{
            border-bottom: 0;
          }
        }
        .doc-tips {
          display: block;
          margin: 5px 0;
          font-size: 14px;
          font-weight: 400;
          color: $dark;
        }

        .name-content {
          border: 1px solid #E1E4E8;
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
          text-align: center;
          text-decoration-skip-ink: none;
          height: 18px;
          padding: 1px 8px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

    }
  }
}
</style>
